import BundleBuilder from '@/apps/bundle-builder';

const bundleBuilderMount = document.getElementById('app-bundle-builder');

if (bundleBuilderMount) {
    new BundleBuilder(bundleBuilderMount);
}
